<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Modifier Endroit</h2>
    </div>
  </div>
  <AjouterFormEndroit ref="modifierEndroit" :endroit="endroit"/>
  <div class="row">
    <div v-if="!isDataLoading" class="col">
      <Button @click="modifier"> Sauvegarder </Button>
    </div>
    <div v-else class="col">      
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AjouterFormEndroit from '../../../../components/pilotage/Fichiers/Endroit/AjouterFormEndroit.vue'
export default {
  components : {
      AjouterFormEndroit
  },
  data() {
    return {
      isDataLoading : false
    }
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Modifier Endroit");
  },
  computed: {
    ...mapGetters({
      endroit: "pilotage/endroitToUpdate",
    }),
  },
  methods: {
    modifier() {
      this.isDataLoading = true;
      let endroit = this.$refs.modifierEndroit.getEndroitLocal();
      this.$store.dispatch('pilotage/modifierEndroitAction', {endroit: endroit})
      .then(() => {
        this.isDataLoading = false;
        this.$toast.add({
          severity:'success',
          summary: 'Modifier Endroit',
          detail:"La modification a été effectué",
          life: 6000
        });
      })
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
}
</script>